import * as v from "valibot";
import { SETTING_KEYS } from "../../settings";
import { pageRequest, pageResponse } from "../paging.dto";

export const adminUserDto = v.object({
  id: v.string(),
  email: v.string(),
  name: v.string(),
  provider: v.picklist(["google", "apple", "email"]),
  platform: v.nullable(v.picklist(["web", "ios", "android"])),
  createdAt: v.number(),
  updatedAt: v.number(),
});
export type AdminUser = v.InferOutput<typeof adminUserDto>;

export const adminUserSettingDto = v.object({
  key: v.picklist(SETTING_KEYS),
  value: v.string(),
  /** False when the user never saved it and the default applies. */
  isDefault: v.boolean(),
});
export type AdminUserSetting = v.InferOutput<typeof adminUserSettingDto>;

export const listAdminUsersRequest = {
  /** An exact (case-insensitive) email; without it the list is newest first. */
  email: v.optional(v.pipe(v.string(), v.maxLength(320))),
  ...pageRequest,
};
export const listAdminUsersResponse = { users: v.array(adminUserDto), ...pageResponse };

export const adminUserIdRequest = { id: v.pipe(v.string(), v.minLength(1), v.maxLength(64)) };

export const getAdminUserResponse = { user: adminUserDto, settings: v.array(adminUserSettingDto) };

export const putAdminUserSettingRequest = {
  ...adminUserIdRequest,
  key: v.picklist(SETTING_KEYS),
  value: v.pipe(v.string(), v.maxLength(64)),
};
export const putAdminUserSettingResponse = { settings: v.array(adminUserSettingDto) };
